import api from "../api/client";
const options = {
    adminEntityEndpoint: "api/v1/Entity",
    adminAgencyEndpoint: "api/v1/Agency",
    adminAccountingOfficeEndpoint: "api/v1/AccountingOffice",
    adminMediaOfficeEndpoint: "api/v1/MediaOffice",
    data: {},
};
export default {
    GetEntities(data, token) {
        options.token = token;
        options.data = data;
        options.endpoint = `${options.adminEntityEndpoint}/List`;
        return api.list(options);
    },
    AddEntity(data, token) {
        options.data = data;
        options.token = token;
        options.endpoint = `${options.adminEntityEndpoint}/`;
        return api.post(options);
    },
    UpdateEntity(id, data, token) {
        options.data = data;
        options.token = token;
        options.id = id;
        options.endpoint = `${options.adminEntityEndpoint}`;
        return api.put(options);
    },
    AddAgency(data, token) {
        options.data = data;
        options.token = token;
        options.endpoint = `${options.adminAgencyEndpoint}/`;
        return api.post(options);
    },
    GetAllAgencies(data, token) {
        options.token = token;
        options.data = data;
        options.endpoint = `${options.adminAgencyEndpoint}/GetAllAgencies/`;
        return api.get(options);
    },
    UpdateAgency(id, data, token) {
        options.data = data;
        options.token = token;
        options.id = id;
        options.endpoint = `${options.adminAgencyEndpoint}`;
        return api.put(options);
    },
    AddAccountingOffice(data, token) {
        options.data = data;
        options.token = token;
        options.endpoint = `${options.adminAccountingOfficeEndpoint}/`;
        return api.post(options);
    },
    UpdateAccountingOffice(id, data, token) {
        options.data = data;
        options.token = token;
        options.id = id;
        options.endpoint = `${options.adminAccountingOfficeEndpoint}`;
        return api.put(options);
    },
    GetAllAccountingOffices(data, token) {
        options.token = token;
        options.data = data;
        options.endpoint = `${options.adminAccountingOfficeEndpoint}/GetAllAccountingOffices/`;
        return api.get(options);
    },
    GetAccountingOfficeCodes(token, data) {
        options.token = token;
        options.endpoint = `${options.adminAccountingOfficeEndpoint}/GetAccountingOfficeCodes/?entityCode=${data.entityCode}&agencyId=${data.agencyId}`;
        return api.get(options);
    },
    AddMediaOffice(data, token) {
        options.data = data;
        options.token = token;
        options.endpoint = `${options.adminMediaOfficeEndpoint}/`;
        return api.post(options);
    },
    UpdateMediaOffice(id, data, token) {
        options.data = data;
        options.token = token;
        options.id = id;
        options.endpoint = `${options.adminMediaOfficeEndpoint}`;
        return api.put(options);
    },
    GetAllMediaOffices(data, token) {
        options.token = token;
        options.data = data;
        options.endpoint = `${options.adminMediaOfficeEndpoint}/GetAllMediaOffices/`;
        return api.get(options);
    },
    GetMediaOfficeCodes(token, data) {
        options.token = token;
        options.endpoint = `${options.adminMediaOfficeEndpoint}/GetMediaOfficeCodes/?entityCode=${data.entityCode}&agencyId=${data.agencyId}&accOfficeCode=${data.accOfficeCode}`;
        return api.get(options);
    },
};